import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/external-api-debug',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/ExternalApiDebugContainer',
      './modules/externalApiDebug'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ExternalApiDebug = require('./containers/ExternalApiDebugContainer').default
      const actions = require('./modules/externalApiDebug')
      const reducer = require('./modules/externalApiDebug').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'externalApiDebug', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, ExternalApiDebug)

    /* Webpack named bundle   */
    }, 'externalApiDebug')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ExternalApiDebug/index.js